module.exports = __webpack_public_path__ + "img/link-2.63d032dd.svg";